

















import { CloseProjectCommand, SuspendProjectCommand } from "@/api/project-api";
import { Component, Prop, Vue } from "vue-property-decorator";
import { IProjectListItem } from "./VProjectList.vue";

interface Action {
  id: string;
  label: string;
  click: (item: IProjectListItem) => unknown;
  disabled?: boolean;
}

@Component({})
export default class ProjectListActions extends Vue {
  @Prop({ required: true }) item!: IProjectListItem;

  get actions(): Action[] {
    const actions: Action[] = [
      {
        id: "suspend",
        label: "保留にする",
        disabled: !["未着工", "施工前", "施工中"].includes(this.item.status),
        click: item => {
          if (
            !confirm(
              "現場内の全ての工程が保留になります。本当に実行してもよろしいですか？"
            )
          ) {
            return;
          }
          const command: SuspendProjectCommand = {
            id: Number(item.project.id),
            pending: true
          };
          this.$emit("suspend", command);
        }
      },
      {
        id: "unsuspend",
        label: "保留を解除する",
        disabled: !["保留"].includes(this.item.status),
        click: item => {
          const command: SuspendProjectCommand = {
            id: Number(item.project.id),
            pending: false
          };
          this.$emit("suspend", command);
        }
      },
      {
        id: "close",
        label: "現場を終了にする",
        disabled: ["施工終了"].includes(this.item.status),
        click: item => {
          if (!confirm("本当に現場を終了してもよろしいですか？")) {
            return;
          }
          const command: CloseProjectCommand = {
            id: Number(item.project.id),
            closed: true
          };
          this.$emit("close", command);
        }
      },
      {
        id: "open",
        label: "終了した現場を再開する",
        disabled: !["施工終了"].includes(this.item.status),
        click: item => {
          const command: CloseProjectCommand = {
            id: Number(item.project.id),
            closed: false
          };
          this.$emit("close", command);
        }
      }
    ];
    return actions.filter(a => !a.disabled);
  }
}
